// @flow
import { connect } from 'react-redux';
import FacetMenu from 'brastrap/promotional/results-facets/ResultsFacetsMenu';

const mapStateToProps = ({ layer }) => ({
  layerIsVisible: layer.isVisible,
});

export default connect(mapStateToProps)(FacetMenu);
